module.exports = __webpack_public_path__ + "img/module-not_notice.png?863be437";